import React from 'react';
import { List } from 'immutable';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  BreadcrumbsFromMenu,
  WysiwygField,
  FadeWrapper,
} from '../../../components';


import './style.scss';

const NodeOverviewPage = ({ entity, className }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'processed'], '');

  return (
    <article className="NodeOverviewPage">
      <Container large>
        <BreadcrumbsFromMenu />
      </Container>
      <Container>
        <div className="row">
          <div className="col-12 col-lg-8">
            <div className="NodeOverviewPage__title">
              <h1>{title}</h1>
            </div>
            <div className="NodeOverviewPage__body">
              <WysiwygField
                property="schema:text"
                html={body}
              />
            </div>
          </div>
        </div>
      </Container>

      {/* Start of paragraphs */}
      {entity.get('field_paragraphs') ? (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            return (
              <FadeWrapper key={`paragraph:${id}`}>
                <Paragraph
                  id={id}
                  entity={paragraph.get('entity')}
                />
              </FadeWrapper>
            );
          })}
        </div>
      ) : null}
      {/* End of paragraphs */}

    </article>
  );
};

export default NodeOverviewPage;
